import { ISelectOption } from '../../../../core/interfaces/select-option';

export class FeeFieldSettings {

    static vatOptions: Array<ISelectOption> = [
        {value: 'n/a', label: 'n/a'},
        {value: 0, label: '0%'},
        {value: 0.135, label: '13.5%'},
        {value: 0.2, label: '20%'},
        {value: 0.21, label: '21%'},
        {value: 0.23, label: '23%'}
    ];

    static currencyOptions: Array<ISelectOption> = [
        {value: 'GBP', label: '£'},
        {value: 'EUR', label: '€'},
        {value: 'USD', label: '$'}
    ];
}



// WEBPACK FOOTER //
// ./src/vas/controls/fee/form/fee-control.settings.ts